import React, { useState, useEffect } from "react";

import Button from "react-bootstrap/Button";
import "./SubTopic.css";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Stack from "react-bootstrap/Stack";
import axios from "axios";
import { marked } from "marked";
import Spinner from "react-bootstrap/Spinner";
import {
  faChartBar,
  faSnowflake,
  faArrowAltCircleRight,
} from "@fortawesome/free-regular-svg-icons";
import { faRotateBack } from "@fortawesome/free-solid-svg-icons";
import { format } from "sql-formatter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "react-bootstrap/Modal";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  TimeScale,
  ScatterController,
} from "chart.js";
import "./CustomComponent.css";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  TimeScale,
  ScatterController,
  Title,
  Tooltip,
  Legend
);
import { Pie, Bar, Line, Scatter } from "react-chartjs-2";

export const SummaryView = (props) => {
  const [messageContent, setMessageContent] = useState(props.summary);

  const [isLoading, setIsLoading] = useState(false);

  console.log("SUMMARY RECEIVED IN VIEW", props.summary);
  function format_text(text) {
    if (!text) {
      //   refreshSummary();
      return "";
    }
    return marked(text);
  }
  function refreshSummary() {
    setIsLoading(true);
    axios
      .post(
        process.env.REACT_APP_API_DOMAIN + "/generateSummary",
        {
          reportId: props.reportId,
        },
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        props.setSummary(response.data.summary);
        setIsLoading(false);
      });
  }
  return (
    <div className="summaryContainer">
      <div className="subTopicTitle"> {props.report.title}</div>

      <div className="subTopicSlide">
        <div className="subTopicSummary">
          {isLoading || props.summary == "" || !props.summary ? (
            <div className="monitorLoader">
              {" "}
              Generating Overview
              <p></p>
              <Spinner animation="border" variant="secondary" />
            </div>
          ) : (
            <div
              dangerouslySetInnerHTML={{
                __html: format_text(props.summary),
              }}
            ></div>
          )}
        </div>
      </div>
      <Stack direction="horizontal" gap={11111}>
        {!props.isShare ? (
          <div className="promptView">
            <Button onClick={refreshSummary} variant="link">
              <FontAwesomeIcon
                className="subtopic_options"
                icon={faRotateBack}
                size="lg"
              />
            </Button>
          </div>
        ) : (
          <div className="promptView"></div>
        )}

        <div className="slideNumberContainer">Slide {1}</div>
      </Stack>
    </div>
  );
};

export default SummaryView;
